import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import {AppButton} from 'components/buttons';
import {AppControlledInput} from 'components/form';
import {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {useLocation, useNavigate} from 'react-router-dom';
import {SetPasswordModel} from 'models';
import {useConfirmEmailApi} from 'hooks';

export const AuthSetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Extract query params
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token') || '';
    const userId = queryParams.get('userid') || '';

    // API hook
    const {confirmEmail, confirmEmailLoading: loading, confirmEmailResponse} = useConfirmEmailApi();

    // Form handling
    const {
        handleSubmit,
        control,
        watch,
        formState: {isValid, isSubmitting},
    } = useForm<SetPasswordModel>({
        defaultValues: {password: '', confirmPassword: '', userId, token},
        mode: 'onChange',
    });

    const hasEnteredValues = watch('password')?.trim() !== '' || watch('confirmPassword')?.trim() !== '';

    const onSubmit = (values: SetPasswordModel) => {
        if (values.token && values.userId) {
            confirmEmail({
                variables: {
                    token: values.token,
                    userId: values.userId,
                    password: values.password,
                },
            });
        }
    };

    useEffect(() => {
        if (!loading && confirmEmailResponse) {
            navigate('/login');
        }
    }, [loading, confirmEmailResponse, navigate]);

    return (
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Stack spacing={1}>
                        <AppControlledInput
                            control={control}
                            fullWidth
                            label="Password"
                            name="password"
                            type="password"
                            rules={{
                                required: 'Password is required',
                                minLength: {value: 8, message: 'Password must be at least 8 characters long'},
                            }}
                        />
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Stack spacing={1}>
                        <AppControlledInput
                            control={control}
                            fullWidth
                            label="Confirm Password"
                            name="confirmPassword"
                            type="password"
                            rules={{
                                required: 'Confirm Password is required',
                                minLength: {value: 8, message: 'Confirm Password must be at least 8 characters long'},
                                validate: value => value === watch('password') || 'Passwords do not match',
                            }}
                        />
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <AppButton
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={!isValid || !hasEnteredValues || isSubmitting}
                        isLoading={loading}
                    >
                        Save Password
                    </AppButton>
                </Grid>
            </Grid>
        </form>
    );
};

export default AuthSetPassword;
